import { render, staticRenderFns } from "./AlreadySub.vue?vue&type=template&id=0face914&scoped=true&"
import script from "./AlreadySub.vue?vue&type=script&lang=js&"
export * from "./AlreadySub.vue?vue&type=script&lang=js&"
import style0 from "./AlreadySub.vue?vue&type=style&index=0&id=0face914&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0face914",
  null
  
)

export default component.exports